module.exports = __webpack_public_path__ + "static/media/你好万寿.79b12cbc.jpg";